import * as core from '../../../../../core'
import * as organization from '../apps/summit/pages/organization'

export const RESOURCE = {
  payload: {
    agentId: core.agent.Agent.Id.OrgChart,
    pageContext: {
      pageAliases: [organization.RESOURCE.payload.alias],
    },
  },
  type: core.quiver.Resource.Type.Agent,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.Agent>
